import { render, staticRenderFns } from "./RecommendationHandler.vue?vue&type=template&id=40694fce"
import script from "./RecommendationHandler.vue?vue&type=script&lang=js"
export * from "./RecommendationHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports